module.exports = __webpack_public_path__ + "static/media/0301dco.d9bdcb97.mov";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0301dco.mov
// module id = 392
// module chunks = 0